const CONSOLE_NOTIFICATION_PREFIXES = [
  '/home',
  '/reports',
  '/people',
  '/groups',
  '/committees',
  '/messaging',
  '/subscriptions',
  '/hubtel',
  '/giving',
  '/payments',
  '/prayer',
  '/settings',
  '/account',
  '/notifications',
  '/content',
  '/calendar',
  '/services',
  '/programs',
  '/attendance',
  '/projects',
  '/expenses',
  '/financial-position',
  '/budgets',
  '/evangelism',
  '/community',
  '/pastoral',
  '/documents',
  '/sacraments',
  '/assets',
  '/branches',
  '/audit',
  '/search',
  '/support',
] as const;

const REPORT_RESERVED_SEGMENTS = new Set(['favorites', 'combined', 'custom']);

/** Normalizes stored deep links to paths the console router understands. */
export const normalizeConsoleDeepLink = (path: string): string => {
  if (path === '/account/security') return '/settings/security';
  if (path === '/hubtel') return '/payments';

  if (path.startsWith('/reports?')) return path;

  const reportMatch = /^\/reports\/([^/?#]+)$/.exec(path);
  if (reportMatch && !REPORT_RESERVED_SEGMENTS.has(reportMatch[1]!)) {
    return `/reports?report=${encodeURIComponent(reportMatch[1]!)}`;
  }

  return path;
};

const isAllowedConsolePath = (path: string): boolean =>
  CONSOLE_NOTIFICATION_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`));

export const resolveConsoleNotificationLink = (deepLink: string | null | undefined): string | null => {
  if (!deepLink?.trim()) return null;

  let trimmed = deepLink.trim();

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed);
      trimmed = `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return '/notifications';
    }
  }

  if (!trimmed.startsWith('/')) return '/notifications';

  const normalized = normalizeConsoleDeepLink(trimmed);
  if (!isAllowedConsolePath(normalized)) return '/notifications';
  return normalized;
};
